module.exports = __webpack_public_path__ + "img/prisma_diagramm.ba835708.png";